import React, { Component } from 'react'
import { withRouter, NavLink } from 'react-router-dom'
import { NavStyle, SecondaryNav, HeaderMenuStyle } from '../../../styles'
import { Search, Account, Notifications, Bookmarks } from '../../../components'

import Logo from './Logo'
import Panel from './Panel'

class HeaderDesktop extends Component {
  state = {
    navPanel: false,
    accountPanel: false,
    notificationPanel: false,
    panelItem: '',
    load: false,
  }

  componentWillReceiveProps({location}){
    if (this.props.location.pathname !== location.pathname) {
      this.resetAllPanel()
    }
  }

  getPanelItem = (val) => (e) => {
    e.preventDefault()
    this.setState({ load: false })
    const hasActive = document.querySelector('.main-nav--item.active')
    const hasActiveDisable = document.querySelector('.main-nav--item.active.disable')
    let textActive = ''
    if (hasActive) textActive = hasActive.querySelector('span:first-child').textContent.toLowerCase()

    if ( val !== this.state.panelItem ) {
      if ( hasActive && val !== textActive) hasActive.classList.add('disable')
    } else {
      if ( hasActiveDisable ) hasActiveDisable.classList.remove('disable')
    }

    this.timeout = setTimeout(() => {
      this.setState({
        panelItem: val !== this.state.panelItem ? val : '',
        navPanel: val !== this.state.panelItem,
        load: true,
        notificationPanel: this.state.notificationPanel,
      }, () => {
        document.body.style.overflow = val !== this.state.panelItem ? 'auto' : 'hidden'
      })
    }, this.state.navPanel ? 300 : 0 )
  }

  updateAccountPanel = () => {
    this.setState({ accountPanel: !this.state.accountPanel, notificationPanel: false })
  }

  updateNotificationPanel = () => {
    this.setState({
      notificationPanel: !this.state.notificationPanel,
      accountPanel: false,
      panelItem: this.state.panelItem,
      navPanel: this.state.navPanel,
     }, () => {
      document.body.style.overflow = 'auto'
     })
  }

  closeSecondaryPanel = () => {
    this.setState({ notificationPanel: false, accountPanel: false })
  }

  resetAllPanel = () => {
    this.closeSecondaryPanel()
    this.setState({
      navPanel: false
    }, () => {
      document.body.style.overflow = 'auto'
    })
  }

  handlerOpenMenu = (e) => {
    e.preventDefault()
    this.setState({
      notificationPanel: this.props.viewport.isMobile ? false : this.state.notificationPanel,
      panelItem: '',
      navPanel: false,
    }, () => {
      document.body.style.overflow = 'auto'
    })
  }

  isActive = (item) => {
    const location = this.props.location.pathname.split('/')
    if (item === 'brand') {
      return location.includes(item) || location.includes('friends-and-partners') || location.includes('materials') || location.includes('complications')
    }

    return location.includes(item)
  }

  callback = (e) => {
    e.preventDefault()
    this.resetAllPanel()
    this.setState({
      panelItem: '',
    })
  }

  render () {
    const { panelItem, notificationPanel, accountPanel, navPanel, load } = this.state
    const { location } = this.props
    return (
      <div className={HeaderMenuStyle(notificationPanel || accountPanel)}>
         <div className="header flex">
            <div onClick={this.callback}>
              <Logo />
            </div>

            <div className={`${NavStyle} main-nav`}>
              <ul className="reset flex">
                {
                  location.pathname === '/' ?
                    <NavLink to='/' className={`main-nav--item ${ panelItem === '' ? 'in-view' : ''}`} onClick={this.clearPanel}>
                      <div className="middle">
                        <span><Search width={24} height={24} /> Search</span>
                      </div>
                    </NavLink>
                  :
                  <li className={`main-nav--item ${ panelItem === 'search' ? 'active' : ''}`} onClick={this.getPanelItem('search')} >
                    <div className="middle">
                      <span><Search width={24} height={24} /> Search</span>
                    </div>
                  </li>
                }

                <li className={`main-nav--item ${ panelItem === 'news' || this.isActive('news') || this.isActive('social-media') ? 'active' : ''}`} onClick={this.getPanelItem('news')}>
                  <div className="middle">
                    <span>News</span>
                  </div>
                </li>
                <li className={`main-nav--item ${ (panelItem === 'models' || this.isActive('models')) || this.isActive('class') ? 'active' : ''}`} onClick={this.getPanelItem('models')}>
                  <div className="middle">
                    <span>Models</span>
                  </div>
                </li>
                <li className={`main-nav--item ${ panelItem === 'brand' || this.isActive('brand') ? 'active' : ''}`} onClick={this.getPanelItem('brand')}>
                  <div className="middle">
                    <span>Brand</span>
                  </div>
                </li>
                {/* Uncomment when Training panel should be visible */}
                {/* <li className={`main-nav--item ${ panelItem === 'training'  || this.isActive('training') ? 'active' : ''}`} onClick={this.getPanelItem('training')}>
                  <div className="middle">
                    <span>Training</span>
                  </div>
                </li> */}
                <li className={`main-nav--item item-challenge ${ panelItem === 'challenge' ? 'active' : ''}`} onClick={this.getPanelItem('challenge')}>
                  <div className="middle">
                    <span> Challenge</span>
                    {/* <span className="main-nav--desc"> Become a watchman ! </span> */}
                  </div>
                </li>
              </ul>
            </div>

            <div className={`secondary-nav flex ${ SecondaryNav }`}>
              <div className="profile-nav">
                <Account open={ accountPanel }  callbackClick={ this.updateAccountPanel } />
              </div>
              <div className="btn--icon btn notification-nav">
                <Notifications open={ notificationPanel } callbackClick={ this.updateNotificationPanel } />
              </div>
              <div className="btn--icon btn bookmarks-nav">
                <Bookmarks />
              </div>
            </div>
          </div>

          <div className='header-outside' onClick={this.closeSecondaryPanel} />
          <Panel open={navPanel} isLoad={load} content={panelItem} isMobile={false} />
      </div>
     )
  }
}

export default withRouter(HeaderDesktop)



// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/HeaderDesktop.js